import angular from 'angular';
import Admin from './admin/admin';
import Attendance from './attendance/attendance';
import Email from './email/email';
import Group from './group/group';
import Home from './home/home';
import City from './city/city';
import State from './state/state';
import Differential from './differential/differential';
import Service from './service/service';
import Login from './login/login';
import News from './news/news';
import Page from './page/page';
import Region from './region/region';
import Unit from './unit/unit';
import Procedure from './procedure/procedure';
import Vaccine from './vaccine/vaccine';
import Target from './target/target';
import Campaign from './campaign/campaign';
import Client from './client/client';
import Card from './card/card';
import Insurance from './insurance/insurance';
import Notification from './notification/notification';
import Me from './me/me';
import Apiaccesslog from './apiaccesslog/apiaccesslog';
import AppVersion from './version/version';
import Faq from './faq/faq';
import Categories from './categories-faq/categories';
import PopUp from './pop-up/pop-up';
import TimeTitle from './title-time/time-title'

let componentModule = angular.module('app.components', [
  Admin,
  Attendance,
  Email,
  Campaign,
  Card,
  Client,
  Group,
  City,
  Differential,
  Home,
  Login,
  Me,
  Apiaccesslog,
  News,
  Notification,
  Page,
  Procedure,
  Region,
  Service,
  State,
  Target,
  Unit,
  Vaccine,
  Insurance,
  AppVersion,
  Faq,
  Categories,
  PopUp,
  TimeTitle,
])

.name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js